import { useNavigate } from 'react-router-dom';
import { useState } from 'react'
import swal from 'sweetalert'
import LoadingSpinner from '../LoadingSpinner';
import ReactFileReader from 'react-file-reader';
import { useUploadNewImageMutation } from '../../Features/frontEndImagesSlice';

function UploadFrontEndImageView() {
    const navigate = useNavigate();

    const [input, setInput] = useState({
        image: '',
        description: ''
    })

    const [errors, setErrors] = useState({
        image: '',
        description: '',
    })

    const [uploadNewImage, {isLoading}] = useUploadNewImageMutation();

    const handleChange = (e)=>{
        setInput({...input, [e.target.name]: e.target.value})
    }

    const handleSubmit = async(e)=>{
        e.preventDefault();
        try {
            const resp = await uploadNewImage(input).unwrap()
            swal("Success",resp.message,"success");
            navigate(-1);
        } catch (err) {
            console.log(err)
            if(err.data.hasOwnProperty('errors') == true){
                setErrors({...errors, image: err.data.errors.image, description: err.data.errors.description})
            }else if (err.data.hasOwnProperty('error') == true){
                setInput({...input, errorMassage: err.data.error})
            }
        }          
    }

    const handleFile = (file) =>{
        setInput({...input, image: file.base64})
    }

    const back = ()=> navigate(-1);

    let constent = isLoading 
                ? <LoadingSpinner />
        :
        (
            <div className="bg-gray-100 h-screen">
                <div className="flex items-center justify-center bg-gray-300 p-1 mb-10">
                    <h1 className="text-sm text-gray-500 uppercase font-semibold p-2">Front End Images management</h1>
                </div>
                <div class="mt-10 sm:mt-0  md:pt-4">
                    <div class="md:grid md:grid-cols-2 md:pr-20 md:pl-20 lg:pr-72 lg:pl-72">
                        <div class="mt-5 md:mt-0 md:col-span-2">
                            <form onSubmit={handleSubmit} autoComplete="off" >
                                <div class=" shadow overflow-hidden sm:rounded-md">
                                        <div class="col-span-6 p-4 shadow-md bg-gray-400 uppercase">
                                            <div className='flex justify-center'>
                                                <h1 className='uppercase font-semibold text-sm text-gray-700 text-white'>Upload a new image</h1>
                                            </div>
                                        </div>
                                <div class="px-4 py-5 bg-gray-200 sm:p-6">
                                    <div class="grid grid-cols-2 gap-4">
                                        <div class="col-span-6 sm:col-span-3">
                                            <label for="description" class="block text-sm font-medium text-gray-700">Description</label>
                                            <textarea 
                                                class="mt-1 p-2 h-20 outline-none focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                                type="text"
                                                placeholder='Description text...'
                                                name="description" 
                                                id="description" 
                                                value={input.description}
                                                onChange={handleChange}
                                            />
                                            <p className="block text-sm font-medium text-red-600 p-0 m-0">{errors.description}</p>
                                        </div>
                                    </div>
                                    <div class="flex flex-col bg-gray-200">
                                    <div className='flex flex-col items-center p-2'>
                                        <ReactFileReader 
                                            className='flex justify-center items-center space-x-2 cursor-pointer'
                                            multipleFiles={false}
                                            base64={true}
                                            handleFiles={handleFile}
                                        >
                                            <p className='bg-gray-300 pr-1 pl-1 border border-gray-400'>Upload Logo</p>
                                            {/* <input type="file" name="logo" className='text-sm' /> */}
                                        </ReactFileReader>
                                        <p className="block text-sm font-medium text-red-500 p-0 m-0">{errors.image}</p>
                                    </div>
                                </div>
                                </div>
                                <div class="flex justify-center space-x-6 items-center px-4 py-4 bg-gray-300 text-right sm:px-6">
                                    <div onClick={back} class="w-20 inline-flex justify-center py-1 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md bg-gray-400 hover:bg-gray-500 cursor-pointer">Cancel</div>
                                    <button type="submit" class="w-20 inline-flex justify-center py-1 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-500 hover:bg-blue-600">Save</button>
                                </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )

    return constent;
}

export default UploadFrontEndImageView;
